import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    serviceType: 0,
    testConfirmation: false,
    checkBoxStatus: true,
    whatsappCheckBoxStatus: true,
    configurationData: '',
    testSmsTemplateId:'',
    smsStandardTemplates: {
        isLoading: false,
        data: null,
        smsTemplateLoadError: '',
        currentStatusData:null,
        reload: false
    },
};

const communicationSlice = createSlice({
    name: "communication",
    initialState,
    reducers: {
        serviceTypeStatus: (state, { payload }) => {
            state.serviceType = payload;
        },
        setTestConfirmation: (state, { payload }) => {
            state.testConfirmation = payload;
        },
        setTestSmsTemplateId: (state, { payload }) => {
            state.testSmsTemplateId = payload;
        },
        setCheckBoxStatus: (state, { payload }) => {
            state.smsStandardTemplates.currentStatusData[payload.smsTemplateId].status = payload.checkStatus;
        },
        setScheduleHr: (state, { payload }) => {
            state.smsStandardTemplates.currentStatusData[payload.smsTemplateId].scheduleHr = payload.scheduleHr;
        },
        setWhatsappCheckBoxStatus: (state, { payload }) => {
            state.whatsappCheckBoxStatus = payload;
        },
        setConfigurationData: (state, { payload }) => {
            state.configurationData = payload;
        },
        smsTemplateLoadingPending: (state) => {
            state.smsStandardTemplates.isLoading = true;
        },
        smsTemplateLoadingSuccess: (state, { payload }) => {
            state.smsStandardTemplates.isLoading = false;
            state.smsStandardTemplates.data = payload;
            const payloadClone = JSON.parse(JSON.stringify(payload));
            let currentStatusDataObj = {};
            payloadClone.forEach((st) => {
                currentStatusDataObj[st.smsTemplateId] = {
                    smsTemplateId:st.smsTemplateId,
                    smsTemplateClientStatusId:st.smsTemplateClientStatusId,
                    scheduleHr:st.scheduleHr,
                    status:st.status
                }
            });
            state.smsStandardTemplates.currentStatusData = currentStatusDataObj;
            state.smsStandardTemplates.reload = false;
        },
        smsTemplateLoadingFailed: (state, { payload }) => {
            state.smsStandardTemplates.isLoading = false;
            state.smsStandardTemplates.data = []
            state.smsStandardTemplates.smsTemplateLoadError = payload;
            state.smsStandardTemplates.reload = false;
        },
        setSmsStandardTemplatesReload: (state, { payload }) => {
            state.smsStandardTemplates.reload = payload;
        }
    },
});

const { reducer, actions } = communicationSlice;

export const { serviceTypeStatus, setTestConfirmation, setTestSmsTemplateId, setCheckBoxStatus, 
    setScheduleHr, setConfigurationData, setWhatsappCheckBoxStatus, 
    smsTemplateLoadingPending, smsTemplateLoadingSuccess, smsTemplateLoadingFailed,
    setSmsStandardTemplatesReload } = actions;

export default reducer;